module.exports = __webpack_public_path__ + "img/nature-17.40b29b96.jpg";